import { cx } from '../util';

export type ClarionSpinnerProps = {
  size?: number;
  color?: string;
  announce?: boolean;
  className?: string;
};

export function ClarionSpinner({
  size = 40,
  color = 'currentColor',
  announce = false,
  className,
}: ClarionSpinnerProps) {
  const strokeWidth = Math.min(10, (50 / size) * 4).toFixed(2);

  const spinner = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={!announce}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke={color}
        strokeWidth={strokeWidth}
        className="opacity-25"
      />
      <path
        d="M25 5 a 20 20 0 0 1 0 40 a 20 20 0 0 1 0 -40"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        className="opacity-75"
        strokeDasharray="90"
        strokeDashoffset="60"
      />
    </svg>
  );

  const announceProps = announce ? { role: 'status', 'aria-live': 'polite' as const } : {};

  return (
    <div
      className={cx('animate-spin flex items-center justify-center', className)}
      {...announceProps}
    >
      {spinner}
      <span className="sr-only">Loading…</span>
    </div>
  );
}
